import { useMemo } from "react";
import { useAuth } from "../App";
import { Banknote } from "lucide-react";
import { ReporteCuentasRecaudadoras } from "./ReportesPage";

export default function ReporteCuentasPage() {
  const { token, API, hasPermission } = useAuth();
  const canExport = hasPermission ? hasPermission("reportes.exportar") : true;
  const auth = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="page-rep-cuentas">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-green-100 text-green-800"><Banknote className="w-6 h-6" /></div>
        <div>
          <h1 className="font-display font-bold text-2xl text-green-900">Recaudación por Cuentas Recaudadoras</h1>
          <p className="text-sm text-green-700/70">Distribución de pagos por cuenta bancaria y tipo de recaudo</p>
        </div>
      </div>
      <ReporteCuentasRecaudadoras auth={auth} API={API} canExport={canExport} />
    </div>
  );
}
